import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { getAllSlots, submitInterviewSlot } from '../../actions';
import { UIShowConfirm } from '../../actions/ui';

class Schedule extends Component {
  constructor (props) {
    super(props);
    this.state = { time_period: 7 };
  }

  _blockTimeSlot = (data) =>
    this.props.submitInterviewSlot(data)
      .then(() => this.loadSlots(this.state.time_period));

  blockTime = (data, timeslot, event) => {
    event.preventDefault();

    this.props.UIShowConfirm('Are you sure want to block the timeslot?', () => this._blockTimeSlot(data));
  };

  loadSlots = time_period => this.props.getAllSlots(time_period);

  loadMore = event => {
    const button = event.target;
    button.disabled = true;
    const time_period = this.state.time_period + 7;
    this.loadSlots(time_period)
      .then(() => {
        this.setState({ time_period });
        button.disabled = false;
      });
  };

  componentDidMount () {
    this.loadSlots(7);
  }

  render () {
    const { slots } = this.props;

    return <div className='col col-12'>
      <div
        className='d-flex align-items-center justify-content-between flex-wrap'>
        <h1 className='mb-3'>Worker Orientation Schedule Slots</h1>
      </div>
      {slots.length ? slots.map(slot => (
        <div key={slot[0]}>
          <hr />
          <div className='d-flex align-items-center mb-3'>
            <h4>{slot[0]}</h4>
          </div>
          <div className='d-flex'>
            {Object.entries(slot[1]).sort((time1, time2) => {
              if (parseInt(time1[0], 10) < parseInt(time2[0], 10)) {
                return -1;
              }
              if (!time1[0].includes('.5') && time2[0].includes('.5') && parseInt(time1[0], 10) === parseInt(time2[0], 10)) {
                return -1;
              }
              return 1;
            }).map(time => {
              let t = time[0].includes('.5') ? time[0].replace('.5', ':30') : `${time[0]}:00`;

              const data = {
                is_full_hour: !time[0].includes('.5'),
                interview_hour: parseInt(time[0].replace('.5', ''), 10),
                interview_date: moment(slot[0]).format('YYYY-MM-DD'),
                user_id: 0
              };

              if (t.length === 4) {
                t = `0${t}`;
              }
              return time[1] ? (
                <button title='Click to block a timeslot'
                  onClick={event => this.blockTime(data, {
                    time: time[0],
                    slot
                  }, event)}
                  key={time[0]} className='button button-badge button-primary mr-2'>{t}</button>
              ) : (
                <button title='Booked' key={time[0]}
                  className='button button-delete button-badge mr-2'>{t}</button>
              );
            })}
          </div>
        </div>
      )) : null}
      <hr />
      <div className='mt-3 pt-3 pb-3 mb-3'>
        <button className='button button-primary' onClick={this.loadMore}>Load more</button>
      </div>
    </div>;
  }
}

const mapStateToProps = state => {
  return {
    slots: Object.entries(state.orientationDates.interviewSlots)
  };
};

const mapDispatchToProps = { getAllSlots, submitInterviewSlot, UIShowConfirm };

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);



// WEBPACK FOOTER //
// ./src/components/app/Schedule.js